export default function Confirmation({ user, result, onRetry, onBackToUnits }) {
  const { score, attemptNumber, maxAttempts, review = [], canRetry, blockedReason } = result || {};

  return (
    <div className="card">
      <div className="attempt-banner">
        Attempt {attemptNumber} of {maxAttempts}
      </div>
      <h2 style={{ marginTop: 8 }}>Submission received</h2>
      <p>Thank you, <strong>{user.name || user.username}</strong>. Your responses for <strong>{user.course}</strong> have been recorded.</p>

      {score && (
        <div className="score-box">
          <div className="score-number">{score.correct} / {score.total}</div>
          <div className="score-percent">{score.percent}%</div>
        </div>
      )}

      {blockedReason && <p className="muted">{blockedReason}</p>}

      <h3 style={{ marginTop: 24 }}>Review</h3>
      {review.map((q, idx) => {
        const options = q.options || {};
        return (
          <div className={`question ${q.isCorrect ? 'review-correct' : 'review-wrong'}`} key={q.id}>
            <h3>
              {idx + 1}. {q.question}{' '}
              <span className={q.isCorrect ? 'badge badge-ok' : 'badge badge-bad'}>
                {q.isCorrect ? 'Correct' : 'Incorrect'}
              </span>
            </h3>
            {Object.entries(options).map(([key, text]) => {
              const isChosen = q.chosen === key;
              const isAnswer = q.correctAnswer === key;
              let cls = 'option review-option';
              if (isAnswer) cls += ' option-correct';
              if (isChosen && !isAnswer) cls += ' option-wrong';
              return (
                <div className={cls} key={key}>
                  <strong>{key}.</strong> {text}
                  {isAnswer && <span className="hint"> correct answer</span>}
                  {isChosen && !isAnswer && <span className="hint"> your answer</span>}
                </div>
              );
            })}
          </div>
        );
      })}

      <div className="footer-actions">
        {canRetry ? (
          <button onClick={onRetry}>Try again</button>
        ) : (
          <span />
        )}
        <button
          onClick={onBackToUnits}
          style={{ background: 'transparent', color: 'var(--brand)' }}
        >
          Back to Units
        </button>
      </div>
    </div>
  );
}
